if (!customElements.get("recipient-form")) {
  customElements.define(
    "recipient-form",
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.addToCartButton = this.querySelector(
          `#ProductSubmitButton-${this.dataset.sectionId}`
        );
        this.validateFormInputs = this.validateFormInputs.bind(this);

        this.inputFields().forEach((input) => {
          if (input) {
            input.addEventListener("input", this.validateFormInputs);
          }
        });

        if (this.checkboxInput) {
          this.checkboxInput.addEventListener(
            "change",
            this.validateFormInputs
          );
        }

          this.recipientFieldsLiveRegion = this.querySelector(
            `#Recipient-fields-live-region-${this.dataset.sectionId}`
          );
          this.checkboxInput = this.querySelector(
            `#Recipient-checkbox-${this.dataset.sectionId}`
          );
          this.checkboxInput.disabled = false;
          this.checkboxInput.checked = true;

          // ✅ Now safe to call
          this.validateFormInputs();

        this.hiddenControlField = this.querySelector(
          `#Recipient-control-${this.dataset.sectionId}`
        );
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(
          `#Recipient-email-${this.dataset.sectionId}`
        );
        this.hiddenControlField.disabled = true;
        this.emailInputCustom = this.querySelector(
          `#Recipient-email-${this.dataset.sectionId}-custom`
        );
        this.nameInput = this.querySelector(
          `#Recipient-name-${this.dataset.sectionId}`
        );
        this.nameInputCustom = this.querySelector(
          `#Recipient-name-${this.dataset.sectionId}-custom`
        );
        this.messageInput = this.querySelector(
          `#Recipient-message-${this.dataset.sectionId}`
        );
        this.messageInputCustom = this.querySelector(
          `#Recipient-message-${this.dataset.sectionId}-custom`
        );
        this.sendonInput = this.querySelector(
          `#Recipient-send-on-${this.dataset.sectionId}`
        );
        this.sendonInputCustom = this.querySelector(
          `#Recipient-send-on-${this.dataset.sectionId}-custom`
        );
        this.offsetProperty = this.querySelector(
          `#Recipient-timezone-offset-${this.dataset.sectionId}`
        );
        if (this.offsetProperty)
          this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.errorMessageWrapper = this.querySelector(
          ".product-form__recipient-error-message-wrapper"
        );
        this.errorMessageList = this.errorMessageWrapper?.querySelector("ul");
        this.errorMessage =
          this.errorMessageWrapper?.querySelector(".error-message");
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener("change", this.onChange.bind(this));
        this.onChange();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          (event) => {
            if (
              event.source === "product-form" &&
              event.productVariantId.toString() === this.currentProductVariantId
            ) {
              this.resetRecipientForm();
            }
          }
        );

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            if (event.data.sectionId === this.dataset.sectionId) {
              this.currentProductVariantId = event.data.variant.id.toString();
            }
          }
        );

        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartError,
          (event) => {
            if (
              event.source === "product-form" &&
              event.productVariantId.toString() === this.currentProductVariantId
            ) {
              this.displayErrorMessage(event.message, event.errors);
            }
          }
        );
        this.checkboxInput = this.querySelector(
          `#Recipient-checkbox-${this.dataset.sectionId}`
        );
        this.emailInput = this.querySelector(
          `#Recipient-email-${this.dataset.sectionId}`
        );
        this.nameInput = this.querySelector(
          `#Recipient-name-${this.dataset.sectionId}`
        );
        this.messageInput = this.querySelector(
          `#Recipient-message-${this.dataset.sectionId}`
        ); 
        this.sendonInput = this.querySelector(
          `#Recipient-send-on-${this.dataset.sectionId}`
        );
        this.submitButton = this.querySelector(".recipient-form__submit");

        // Setup event listeners
        this.inputFields().forEach((input) => {
          if (input)
            input.addEventListener("input", this.validateFormInputs.bind(this));
        });
        if (this.checkboxInput) {
          this.checkboxInput.addEventListener(
            "change",
            this.validateFormInputs.bind(this)
          );
        }

        this.validateFormInputs(); // Initial validation state

        const formLabel = this.querySelector(".mod-Rise_FormDate-active");
        const sendBtn = this.querySelector(".send-now-button[name='properties[Send on]']");
        const easeFields = formLabel?.closest(".risbtabs");
        const dateInput = easeFields?.querySelector(".datepicker");

        if (formLabel && dateInput) {
          formLabel.addEventListener("click", () => {
            dateInput.click();
          });
        }

        if (sendBtn) {
          sendBtn.addEventListener("click", () => {
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, "0");
            const dd = String(today.getDate()).padStart(2, "0");
            const formattedDate = `${yyyy}-${mm}-${dd}`;
            document.body.click();
            document.querySelector(".datepicker_date").textContent = '';
            document.querySelectorAll('.datepicker').forEach(todayDate => {
              todayDate.value = formattedDate;
            });
            this.submitButton.disabled = false;
          });
  }


const recipientBtn = this.querySelectorAll(".recipient-checkbox");
const recipientOverlay = this.querySelector(".recipient_overlay");
const recipientField = this.querySelector(".recipient-fields");
const recipientClose = this.querySelector(".mod-Rise_Close");
if (recipientBtn) {
  recipientBtn.forEach((recipe) => {
  recipe.addEventListener("click", () => {
    document.body.classList.add("overflow-hide");
    recipientField.classList.add("show_form");
    recipientOverlay.classList.toggle("show_overlay");
    console.log("recipientBtn", recipientBtn);

    if (this.sendonInput) this.sendonInput.value = "";
    if (this.sendonInputCustom) this.sendonInputCustom.value = "";
    this.clearAllInputFields();
    this.clearInputFields();
    this.submitButton.disabled = true;
  });
});

}
if (recipientClose) {
  recipientClose.addEventListener("click", function () {
    document.body.classList.remove("overflow-hide");
    recipientOverlay.classList.remove("show_overlay");
    recipientField.classList.remove("show_form");
  });
}
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }
      }
       updateInputs(){
         this.emailInput.value = this.emailInputCustom.value
         this.nameInput.value = this.nameInputCustom.value
         this.messageInput.value = this.messageInputCustom.value
         this.sendonInput.value = this.sendonInputCustom.value
         console.log('Chekcing')
       }
      onChange() {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.recipientFieldsLiveRegion.innerText =
            window.accessibilityStrings.recipientFormExpanded;
          this.updateInputs()
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.recipientFieldsLiveRegion.innerText =
            window.accessibilityStrings.recipientFormCollapsed;
        }
      }

      inputFields() {
        return [
          this.emailInputCustom,
          this.nameInputCustom,
          this.messageInputCustom,
          this.sendonInputCustom,
        ];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ""));
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      validateFormInputs() {
        if (!this.checkboxInput || !this.checkboxInput.checked) {
          this.disableSubmitButton();
          this.toggleVariantContainer(false);
          return;
        }
        

        const allFilled = this.inputFields().every(
          (input) => input && input.value.trim() !== ""
        );
        if (allFilled) {
          this.enableSubmitButton();
          this.toggleVariantContainer(true);
        } else {
          this.disableSubmitButton();
          this.toggleVariantContainer(false);
        }
      }

      toggleVariantContainer(show) {
          const container = document.querySelector(
            `#variant-container-${this.dataset.sectionId}`
          );
          if (container) {
            container.classList.remove("hidden");
          }
        }

      enableSubmitButton() {
        if (this.submitButton) {
          this.submitButton.disabled = false;
        }
      }

      clearAllInputFields(){
        if(this.emailInput) this.emailInput.value = '';
        if(this.messageInput) this.messageInput.value = '';
        if(this.nameInput) this.nameInput.value = '';
        if(this.sendonInput) this.sendonInput.value = '';
      }

      disableSubmitButton() {
        if (this.submitButton) {
          this.submitButton.disabled = true;
        }
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        this.errorMessageWrapper.hidden = false;
        if (typeof body === "object") {
          this.errorMessage.innerText = this.defaultErrorHeader;
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const message = `${value.join(", ")}`;
            const errorMessageElement = this.querySelector(
              `#${errorMessageId}`
            );
            const errorTextElement =
              errorMessageElement?.querySelector(".error-message");
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(
                this.createErrorListItem(fieldSelector, message)
              );
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove("hidden");

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute("aria-invalid", true);
            inputElement.setAttribute("aria-describedby", errorMessageId);
          });
        }

        this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement("li");
        const a = document.createElement("a");
        a.setAttribute("href", target);
        a.innerText = message;
        li.appendChild(a);
        li.className = "error-message";
        return li;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = "";

        this.querySelectorAll(".recipient-fields .form__message").forEach(
          (field) => {
            field.classList.add("hidden");
            const textField = field.querySelector(".error-message");
            if (textField) textField.innerText = "";
          }
        );

        [
          this.emailInput,
          this.messageInput,
          this.nameInput,
          this.sendonInput,
        ].forEach((inputElement) => {
          inputElement.setAttribute("aria-invalid", false);
          inputElement.removeAttribute("aria-describedby");
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = true;
          this.clearInputFields();
          this.clearErrorMessage();
          // this.disableInputFields();
        }
      }
    }
  );
}
// ------------------------------------------
const variantSelectInput = document.querySelector(".product-form input.product-variant-id");
const mainImage = document.querySelector(".mod-Rise_MainImage img");
const subImgBtn = document.querySelectorAll(".mod-Rise_SubImage button");
if (subImgBtn && mainImage && variantSelectInput) {
  subImgBtn.forEach(function (fimg) {
    fimg.addEventListener("click", function () {
      const selectImage = this.getAttribute("data-product-img");
      mainImage.setAttribute("src", selectImage);
      const imgValue = this.getAttribute("value");
      if (!imgValue) return;
      const closeParent = this.closest("product-info");  
      const giftImage  =  closeParent?.querySelectorAll('.gift-card-image')
      giftImage?.forEach( img => img.value = selectImage)
      const matchingOption = closeParent.querySelector(
        `variant-selects.giftVarHid option[value="${imgValue}"]`
      );
      console.log('matchingOption', matchingOption)
      if (matchingOption) {
        const dropdown = matchingOption.closest("select");
        dropdown.value = matchingOption.value;
        dropdown.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });
}
// ----------------
document.addEventListener("DOMContentLoaded", () => {
  const selectEl = document.querySelector(".giftcard-variant-select");
  const productForm = document.querySelector("product-info");
  const priceEl = document.querySelector(".product__info-container .price-item--regular, .product__info-container .price-item--sale");
  if (!selectEl || !productForm) return;

  const addToCartBtn = productForm.querySelector(".gift_ATC");
  const giftCardBtn = productForm.querySelector(".recipient-form");
  const variantInput = productForm.querySelector("input[name='id']");
  console.log('variantInput', variantInput)

  function disableButtons() {
    if (addToCartBtn) addToCartBtn.classList.add("disabled");
    if (giftCardBtn) giftCardBtn.classList.add("disabled");
  }

  function enableButtons() {
    if (addToCartBtn) addToCartBtn.classList.remove("disabled");
    if (giftCardBtn) giftCardBtn.classList.remove("disabled");
  }

  function updateGiftCardState() {
    const selected = selectEl.options[selectEl.selectedIndex];
    const variantId = selected?.dataset?.variantId || "";
    const price = selected?.dataset?.price || "";

        if (!variantId) {
        if(variantInput) variantInput.dataset.id 
        if (addToCartBtn) addToCartBtn.dataset.id = "";
        disableButtons();

        const url = new URL(window.location.href);
        url.searchParams.delete("variant");
        window.history.replaceState({}, "", url.toString());
      } else {
        if (addToCartBtn) addToCartBtn.dataset.id = variantId;
         if (variantInput) variantInput.value = variantId;
        if (priceEl && price) { priceEl.innerHTML = price + ' <span class="currency_icon">₪</span>';}
        enableButtons();

        const url = new URL(window.location.href);
        url.searchParams.set("variant", variantId);
        window.history.replaceState({}, "", url.toString());
      }

  }

  const url = new URL(window.location.href);
  const variantFromUrl = url.searchParams.get("variant");

  if (variantFromUrl) {
    const match = [...selectEl.options].find(
      (opt) => opt.dataset.variantId === variantFromUrl
    );
    if (match) match.selected = true;
  }

  updateGiftCardState();

  selectEl.addEventListener("change", updateGiftCardState);
});
// ------------------------------------------
const inputTextareas = document.querySelectorAll(".recipient_text_area");
const outputText = document.querySelector(".mod-Rise_ImageText p");

inputTextareas.forEach((area) => {
  area.addEventListener("input", (event) => {
    outputText.textContent = `"${event.target.value}"`;
  });
});

document.addEventListener("click", function(event){
  if (event.target.matches('.gift_ATC') || event.target.closest('.gift_ATC')){
    const target = event.target.matches('.gift_ATC') ? event.target : event.target.closest('.gift_ATC');
  const id = parseInt(target.getAttribute('data-id'))
   target?.classList.add('loading')
   window.updateCartDrawer(id , target)
       document.querySelector('#cart-icon-bubble')?.click()
 }
})
window.updateCartDrawer = function(id , target) {
  if (id) {
    function getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
    const config = {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/javascript",
      }
    };
    
    const sectionsToRender = [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cartIconBubble',
        section: 'cart-icon-bubble',
        selector: '.cart-count-section',
      }
    ];
    
    let formData = new FormData();
    formData.append("id", id);
    formData.append("quantity", 1);
    formData.append("sections", sectionsToRender.map((section) => section.section));
    formData.append("sections_url", window.location.pathname);
    config.body = formData;
    
    fetch(`/cart/add`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.message);
          return;
        }
        
        const product = response.hasOwnProperty("items")
          ? response.items[0]
          : response;
        document.querySelector('cart-drawer')?.classList.remove('is-empty')
        target?.classList.remove('loading')
        sectionsToRender.forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          console.log('sectionElement' , sectionElement)
          if(sectionElement){
          sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.section], section.selector);
          }
        });
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  } else {
    console.log("No matching variant found.");
  }
}